module.exports = __webpack_public_path__ + "img/product_logo.790c781e.png";